import React, { Component } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import qs from "qs";
import cx from "classnames";
import Only from "react-only-when";
import { Route, withRouter, Redirect } from "react-router-dom";
import { push, replace } from "react-router-redux";
import { Grid, Container, Responsive } from "semantic-ui-react";
import { SearchResults } from "./SearchResults";
import { RegionResults } from "./RegionResults";
import { AllResults } from "./AllResults";
import { DealsResults } from "./DealsResults";
import AddonsContainer from "./AddonsContainer";
import { ContactUs } from "./ContactUs";
import CartContainer from "./CartContainer";
import Filter from "./Filter";
import {
  RoomDetails,
  HotelDetails,
  AddonDetails,
  SearchboxModal,
  RoomsCancellationPolicy
} from "../components";
import {
  GlobalModal,
  GlobalLoader,
  NoResultsPage,
  AnimatedSwitch
} from "../components/common";
import * as modalActions from "../actions/globalModalActions";
import * as generalActions from "../actions/generalActions";
import * as cartActions from "../actions/cartActions";
import * as roomResultsActions from "../actions/roomResultsActions";
import * as ratesActions from "../actions/ratesActions";
import * as mobileViewActions from "../actions/mobileViewActions";
import * as paxActions from "../actions/paxActions";
import * as contactUsActions from "../actions/contactUsActions";
import { toggleExpandbleView } from "../actions/expandbleViewActions";
import { isRTL, getFirstRoomBySortOrderSelector } from "../reducers";
import * as hotelsActions from "../actions/hotelsActions";
import * as globalNotificationActions from "../actions/globalNotificationActions";
import * as dealActions from "../actions/dealsActions";
import { getPlaceHolders } from "../actions/placeHoldersActions";
import { ToastContainer } from "react-toastr";
import * as screenSize from "../constants/screenSize";
import { PlaceHolderLocation } from "../constants/general";
import { getCurrentScreenType } from "../helpers/domHelpers";
import GalleryPopUp from "../components/GalleryPopUp";
import styles from "./styles.less";
import CurrenciesDropdown from "./CurrenciesDropdown/CurrenciesDropdown";
import { RegistrationPayment } from "./RegistrationPayment";
import { Confirmation } from "./Confirmation";
// import BreadCrumbs from "../components/BreadCrumbs";
import BreadCrumbsDots from "../components/BreadCrumbsDots";

const initialModalData = {
  icon: "",
  open: false,
  content: "",
  closeOnEscape: true,
  closeOnRootNodeClick: true
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      globalModalData: initialModalData
    };
    this.setRouteFromSearchData();
    window.addEventListener("resize", this.updateMobileViewFlag.bind(this));
    // window.addEventListener("beforeunload", function(event) {
    //   event.preventDefault();
    //   //return (event.returnValue = "");
    //   //this.sendCustomerLead();
    // });
  }

  componentDidMount() {
    let self = this;
    window.onbeforeunload = function(event) {
      event.preventDefault();
      self.sendCustomerLead();
    };
    this.getPlaceHolders();
  }

  componentDidUpdate(prevProps) {
    const { globalNotification, searchDataTimestamp } = this.props;
    const {
      globalNotification: prevGlobalNotification,
      searchDataTimestamp: prevSearchDataTimestamp,
      actions
    } = prevProps;
    if (
      globalNotification !== prevGlobalNotification &&
      globalNotification.show
    ) {
      const { msg, type } = globalNotification;
      this.showMessage(msg, type);
      setTimeout(() => {
        actions.hideGlobalNotification();
      }, 0);
    }
    if (searchDataTimestamp && searchDataTimestamp > prevSearchDataTimestamp) {
      this.setRouteFromSearchData();
    }
    window.onpopstate = () => {
      const { actions } = this.props;
      window.beforeunload = null;
      actions.resetSelection();
      actions.resetSelectedPaxIndex();
      actions.resetPaxList();
      actions.changeDisplayRoom(null);
      actions.resetSelectedDeal();
    };
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateMobileViewFlag.bind(this));
  }

  getPlaceHolders() {
    const { actions } = this.props;
    PlaceHolderLocation.forEach(element => {
      actions.getPlaceHolders(element);
    });
  }

  showDialogBeforUnloading = event => {
    event.preventDefault();
    return (event.returnValue = "");
  };

  areYouSure = () => {
    let confMessage =
      "***************************************\n\n W A I T !!! \n\nBefore leaving our site, follow CodexWorld for getting regular updates on Programming and Web Development.\n\n\nCLICK THE *CANCEL* BUTTON RIGHT NOW\n\n***************************************";
    return confMessage;
  };

  sendCustomerLead = async () => {
    const {
      registrationData,
      checkinDate,
      checkoutDate,
      selectedOption,
      paxList,
      lang,
      titles,
      reservationId
    } = this.props;
    if (
      !reservationId &&
      registrationData &&
      (registrationData.Email || registrationData.PhoneNumber)
    ) {
      const roomTypes = paxList && paxList.map(p => p.roomId);
      const emailModel = {
        FirstName: registrationData.FirstName,
        LastName: registrationData.LastName,
        Phone: registrationData.PhoneNumber,
        Email: registrationData.Email,
        MessageContent: null,
        RequestType: titles.UserDidNotFinishReservation,
        SearchDetails: {
          CheckIn: checkinDate,
          CheckOut: checkoutDate,
          SelectedOption: selectedOption,
          Pax: paxList,
          RoomTypes: roomTypes,
          lang: lang
        }
      };
      const formData = {
        emailModel: emailModel,
        lang: lang
      };
      await this.submitContactUsForm(formData);
    }
  };

  updateMobileViewFlag = () => {
    const { actions, isMobileView: oldFlagValue } = this.props;
    const newFlagValue = getCurrentScreenType() < screenSize.DESKTOP_SM;
    if (newFlagValue !== oldFlagValue) {
      actions.changeMobileViewFlag(newFlagValue);
    }
  };

  toggleExpandbleResultsView = () => {
    const { actions } = this.props;
    actions.toggleExpandbleView();
  };

  showMessage = (message, state = "info") => {
    // check for rtl
    this.toastr[state](message.toString(), "", {
      timeOut: 3000,
      closeButton: true,
      className: styles.toastr
    });
  };

  hideMessage = () => {
    // check for rtl
    this.toastr.clear();
  };

  /// render global loader - each container use it.
  renderResultsLoader = (isFetching, loaderTitle = null) => {
    const { titles, isMobileView, isRtl } = this.props;
    const loadertitles = loaderTitle
      ? [loaderTitle]
      : titles.PreparingResults && [
          titles.PreparingResults,
          titles.WeAreAboutToStart
        ];
    return (
      <Grid.Column verticalAlign="middle" stretched>
        <GlobalLoader
          size="massive"
          active={isFetching}
          inline="centered"
          interval={3000}
          contentArray={loadertitles}
          isMobileView={isMobileView}
          isRtl={isRtl}
          indeterminate
        />
      </Grid.Column>
    );
  };

  toggleMenu = () => this.setState(prev => ({ showMenu: !prev.showMenu }));

  onCartShowCancellationPolicy = () => {
    const { titles } = this.props;
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.CancellationPolicy,
        content: this.renderCancellationPolicy(),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  renderCancellationPolicy = () => {
    const {
      rooms,
      paxList,
      titles,
      isRtl,
      isDealMode,
      dealSearchResults
    } = this.props;
    const roomsArray = isDealMode ? dealSearchResults : rooms;

    let result;

    if (!isDealMode) {
      // regular mode - not deal mode
      result = paxList.reduce((acc, curr, index) => {
        let item = {
          ...curr
        };
        let cancelText = "";
        const room = roomsArray[index].find(r => r.id === curr.roomId);
        if (room) {
          item.roomName = room.name;
          const rate = room.rates.find(r => r.id === curr.rateId);
          if (rate) {
            if (rate.cancellationPolicyDescription) {
              cancelText = rate.cancellationPolicyDescription;
            }
          } else {
            return acc;
          }
        } else {
          return acc;
        }
        item.cancellationPolicy = cancelText;
        acc.push(item);
        return acc;
      }, []);
    } else {
      // deal mode only
      result = paxList.reduce((acc, curr, index) => {
        let item = {
          ...curr
        };
        let cancelText = "";
        const deal = roomsArray[index].find(r => r.id === curr.rateId);
        if (deal) {
          item.roomName = deal.name;
          cancelText = deal.rate.cancellationPolicyDescription;
        } else {
          return acc;
        }
        item.cancellationPolicy = cancelText;
        acc.push(item);
        return acc;
      }, []);
    }

    return (
      <RoomsCancellationPolicy cpList={result} titles={titles} isRtl={isRtl} />
    );
  };

  renderMockStripChid = () => {
    return (
      <div style={{ padding: "10px" }}>
        <h3>Some header and content for the strip</h3>
        <h4>Some content for the strip </h4>
        <p>
          Some content for the strip Some content for the strip, Some content
          for the strip, Some content for the strip. Some content for the strip,
          Some content for the strip
        </p>
      </div>
    );
  };

  renderRoomDetails = room => {
    const { isRtl } = this.props;
    return <RoomDetails {...room} isRtl={isRtl} />;
  };

  onShowRoomDetailsClick = roomId => {
    const { rooms, selectedPaxId, titles, alternativeSearch } = this.props;
    let clickedRoom = rooms[selectedPaxId].find(
      room => room.id === roomId.id || room.id === roomId
    );
    if (!clickedRoom) {
      clickedRoom =
        alternativeSearch &&
        alternativeSearch.find(
          item => item.id === roomId.id || item.id === roomId
        );
    }
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.RoomDetails,
        content: this.renderRoomDetails(clickedRoom),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  renderDealExtraDetails = deal => {
    const { isRtl } = this.props;
    return (
      <RoomDetails
        name={deal.name}
        description={deal.description}
        isRtl={isRtl}
      />
    );
  };

  onShowDealExtraDetailsClick = deal => {
    const { titles } = this.props;
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.DealDetails,
        content: this.renderDealExtraDetails(deal),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  renderAddonDetails = addon => {
    const { isRtl } = this.props;
    return <AddonDetails {...addon} isRtl={isRtl} />;
  };

  onShowAddonDetailsClick = addonId => {
    const { addons, selectedPaxId, titles } = this.props;
    const clickedAddon = addons[selectedPaxId].find(
      addon => addon.id === addonId
    );
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.MoreDetails,
        content: this.renderAddonDetails(clickedAddon),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  renderRoomGalleryPopUp = room => {
    const { isRtl } = this.props;
    return <GalleryPopUp room={room} isRtl={isRtl} />;
  };

  onShowRoomGalleryPopUp = room => {
    //const { titles } = this.props;
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        //title: titles.RoomImages,
        title: "",
        content: this.renderRoomGalleryPopUp(room),
        icon: "info circle",
        alignToTop: true
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  renderHotelDetails = hotel => {
    const { isRtl } = this.props;
    return <HotelDetails {...hotel} isRtl={isRtl} />;
  };

  onShowHotelDetailsClick = hotel => {
    const { titles } = this.props;
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.HotelDetails,
        content: this.renderHotelDetails(hotel),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  onRateReadMore = ({ rateId, roomId, render }) => {
    const {
      rooms,
      selectedPaxId,
      titles,
      ShowCancellationPolicy,
      dealSearchResults,
      isDealMode
    } = this.props;
    let clickedData;
    if (!isDealMode) {
      clickedData = rooms[selectedPaxId]
        .find(room => room.id === roomId)
        .rates.find(rate => rate.id === rateId);
    } else {
      clickedData = dealSearchResults[selectedPaxId].find(
        deal => deal.roomId === roomId && deal.id === rateId
      );
    }

    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: !isDealMode ? titles.RateDetails : titles.RoomDetails,
        content: render(clickedData),
        icon: "info circle",
        ShowCancellationPolicy: ShowCancellationPolicy
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  onShowMoreAmenities = ({ roomId, render }) => {
    const { rooms, selectedPaxId, titles } = this.props;
    const amenities = rooms[selectedPaxId].find(room => room.id === roomId)
      .amenities;
    this.setState(prev => {
      const nextModalData = {
        ...prev.globalModalData,
        open: true,
        title: titles.Amenities,
        content: render(amenities),
        icon: "info circle"
      };
      return {
        globalModalData: nextModalData
      };
    });
  };

  onRateSelection = ({ ...selectedRateParams }) => {
    const {
      actions,
      selectedPaxId,
      paxList,
      searchResultsRefAndHandlers,
      dealResultsRefAndHandlers,
      enableSinglePaxCartSkipping,
      singlePaxLoaded,
      rooms,
      addons,
      //isMobileView,
      dealSearchResults,
      isDealMode,
      enableAddonsPopUp
    } = this.props;

    actions.dealStartAnimation();
    const rateSelectActionParams = {
      ...selectedRateParams,
      RequestDescriptor: selectedPaxId
    };

    // Only if single room pax search:
    // As soon the first (the only one) rate was selected, DO NOT slide out the cart ( insteed redirect to registration )
    if (
      enableSinglePaxCartSkipping &&
      singlePaxLoaded &&
      paxList.length === 1
    ) {
      rateSelectActionParams.disableCartSlideOut = true;
    }
    // END Only if

    // un-select current rate if needed (for availability reset)
    const currentPax = paxList.find(p => p.id === selectedPaxId);
    const prevRateId = currentPax.rateId;
    const prevRoomId = currentPax.roomId;
    if (prevRateId && prevRoomId) {
      const unselectedRate = !isDealMode
        ? rooms[selectedPaxId]
            .find(room => room.id === prevRoomId)
            .rates.find(rate => rate.id === prevRateId)
        : dealSearchResults[selectedPaxId].find(
            deal => deal.roomType === prevRoomId
          ).rate;
      const unSelectRateActionParams = {
        ...rateSelectActionParams,
        allocationCode: unselectedRate && unselectedRate.allocationCode,
        rateId: prevRateId,
        roomId: prevRoomId,
        selectedPaxId
      };
      if (isDealMode) {
        actions.dealRateUnSelected(unSelectRateActionParams);
      } else {
        actions.rateUnSelected(unSelectRateActionParams);
      }
    }

    if (isDealMode) {
      actions.dealRateSelected(rateSelectActionParams);
    } else {
      actions.rateSelected(rateSelectActionParams);
    }

    actions.dealEndAnimation();

    // after process for rate selection, this method will always being called.
    // if the special services is enabled so call this method just after the special services modal got closed ( continute to step two - as the method name )
    // if the special services is disabled so call this method with no waiting like it all one step process
    const onRateSelectedStepTwo = () => {
      // select next pax with no product selected
      const nextNoneSelectedPax = paxList.find(
        pax => pax.id !== selectedPaxId && !pax.rateId
      );
      if (nextNoneSelectedPax) {
        this.onPaxItemClick(nextNoneSelectedPax.id);
        if (!isDealMode) {
          // if mobile go to rooms page
          this.routeToRooms();
        }
      } else {
        if (enableSinglePaxCartSkipping) {
          this.onCheckoutClick();
        }
      }
      // notify the parent (for scrolling)
      const { onRateSelection } = searchResultsRefAndHandlers;
      const { onDealRateSelection } = dealResultsRefAndHandlers;
      onRateSelection && onRateSelection(rateSelectActionParams);
      if (isDealMode) {
        onDealRateSelection && onDealRateSelection(rateSelectActionParams);
      }
    };

    //Dina 16/05/19 added "enableAddonsPopUp" property from cdn, defines in pop up should appear
    const isAddonEnabled =
      enableAddonsPopUp &&
      addons[selectedPaxId] &&
      addons[selectedPaxId].length > 0;

    if (isAddonEnabled) {
      this.openSpecialServices().then(onRateSelectedStepTwo);
    } else {
      onRateSelectedStepTwo();
    }
  };

  //Dina 03/01/18 on rate Selected for deals
  // const onDealRateSelected = () => {

  // }

  onPaxItemClick = paxId => {
    const { actions, paxList, rooms, selectedPaxId, isDealMode } = this.props;
    const asNumber = Number.isNaN(paxId) ? paxId : Number(paxId);
    if (!paxList.find(p => p.id === asNumber)) {
      return false;
    }
    if (asNumber !== selectedPaxId) {
      actions.changeSelectedPaxIndex(asNumber);
    }
    if (!isDealMode) {
      const roomsPerPax = rooms[paxId];
      const firstRoomBySortOrder =
        getFirstRoomBySortOrderSelector(roomsPerPax) || {};
      const roomId =
        paxList.find(p => p.id === asNumber).roomId || firstRoomBySortOrder.id;
      if (roomId) {
        actions.changeDisplayRoom(roomId);
      }
    }
  };

  routeToRooms = () => {
    const { actions, routing } = this.props;
    actions.push(
      {
        pathname: "/hotel",
        search: routing.location.search,
        notifyRoute: this.props.notifyRouteChange
      },
      null
    );
  };

  onEditAddons = (paxId, confirmCallback, cancelCallback) => {
    this.onPaxItemClick(paxId);
    this.openSpecialServices(confirmCallback, cancelCallback).then();
  };

  openSpecialServices = (confirmCallback, cancelCallback) => {
    const promise = new Promise(resolve => {
      const onModalClosed = callback => () => {
        callback && callback();
        this.handleModalCancel();
        resolve();
      };

      const { titles } = this.props;
      this.setState(prev => {
        const nextModalData = {
          ...prev.globalModalData,
          open: true,
          title: titles.SpecialServices,
          content: (
            <AddonsContainer
              onCancel={onModalClosed(confirmCallback)}
              onConfirm={onModalClosed(cancelCallback)}
            />
          ),
          icon: "",
          closeOnEscape: false,
          closeOnRootNodeClick: false
        };
        return {
          globalModalData: nextModalData
        };
      });
    });

    return promise;
  };

  handleModalCancel = () => {
    const { actions } = this.props;
    this.setState(prev => {
      const { globalModalData } = prev;
      const nextModalData = {
        ...globalModalData,
        ...initialModalData
      };
      return {
        globalModalData: nextModalData
      };
    });
    actions.dismissGlobalModal;
  };

  showSimpleClubLoginModal = () => {
    document.dispatchEvent(
      new CustomEvent("be_reactAppEventListener", {
        detail: "simpleClubModalOpener"
      })
    );
  };

  setStaticCartRef = ref => (this.staticCart = ref);

  setRouteFromSearchData = () => {
    const {
      selectedRegionId,
      selectedCityCode,
      selectedHotelId,
      selectedDealId,
      lang,
      routing,
      actions
    } = this.props;
    let query = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    let path = "/";

    // don't do noting and return if the page redirected with selected data

    if (routing.location.pathname.indexOf("/registration") > -1) {
      path = "/registration";
    } else if (routing.location.pathname.indexOf("/confirmation") > -1) {
      path = "/confirmation";
    } else if (routing.location.pathname.indexOf("/contactUs") > -1) {
      path = "/contactUs";
    } else if (routing.location.pathname.indexOf("deals/deal") > -1) {
      query.selectedDealId = selectedDealId;
      query.selectedHotelId = selectedHotelId;
      path += "deals/deal";
    } else if (routing.location.pathname.indexOf("/deals") > -1) {
      path = "/deals";
    } else if (selectedHotelId != null) {
      query.selectedHotelId = selectedHotelId;
      path += "hotel";
    } else if (selectedCityCode) {
      query.selectedCityCode = selectedCityCode;
      path += "city";
    } else if (selectedRegionId) {
      query.selectedRegionId = selectedRegionId;
      path += "region";
    } else {
      //support all hotels (sagiv, just checking if it works)
      path = "/all";
    }
    query.lang = lang;
    query = qs.stringify(query, { addQueryPrefix: true });
    actions.push(
      {
        pathname: path,
        search: query,
        notifyRoute: this.props.notifyRouteChange
      },
      null
    );
  };

  submitContactUsForm = formData => {
    const { actions } = this.props;
    actions.sendContactForm(formData);
  };

  getCartHeight = height => this.setState({ cartHeight: height });

  setRedirectFormRef = ref => (this.checkoutForm = ref);

  maybeRenderMobileCart = () => {
    const { isMobileView, ShowCancellationPolicy } = this.props;
    // if (!isMobileView) {
    //   return null;
    // }
    if (isMobileView) {
      return null;
    }
    const toRender = (
      <CartContainer
        getInitialHeight={this.getCartHeight}
        redirectFormRef={this.setRedirectFormRef}
        onItemClick={this.onPaxItemClick}
        onEditAddons={this.onEditAddons}
        ShowCancellationPolicy={ShowCancellationPolicy}
      />
    );
    return toRender;
  };

  maybeRenderDesktopCart = () => {
    const {
      rooms,
      ShowCancellationPolicy,
      isDealMode,
      // isFetchingDealsSearchResultsReducer,
      isMobileView,
      selectedHotelId,
      isRtl,
      dealSearchResults
    } = this.props;
    // TODO: extract "scart" to a prop so we can inject it dynamically
    const portalContainer = document.getElementById("scart");
    if (!portalContainer) {
      // no container rendered for our portal
      return null;
    }
    // if (isMobileView) {
    //   // we are not rendering this on mobile / tablets
    //   return null;
    // }
    const hasResults = !isDealMode
      ? rooms && Object.values(rooms).length > 0
      : dealSearchResults && dealSearchResults.length > 0;

    // const isShowLoader =
    //   (isDealMode && isFetchingDealsSearchResultsReducer) ||
    //   (!isDealMode && !isFetchingDealsSearchResultsReducer);
    const isShowLoader = false;

    const cartLoader = isShowLoader ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100%"
        }}
      >
        <GlobalLoader
          size="massive"
          active={true}
          inline="centered"
          interval={3000}
          showContent={false}
          isMobileView={isMobileView}
          isRtl={isRtl}
          indeterminate
        />
      </div>
    ) : null;

    const cartORLoader =
      selectedHotelId && hasResults ? (
        <CartContainer
          getInitialHeight={this.getCartHeight}
          redirectFormRef={this.setRedirectFormRef}
          onItemClick={this.onPaxItemClick}
          onEditAddons={this.onEditAddons}
          onSubmit={this.onCheckoutClick}
          isShowCancellationPolicy={ShowCancellationPolicy}
          onShowCancellationPolicy={this.onCartShowCancellationPolicy}
        />
      ) : (
        cartLoader
      );
    let toRender;

    toRender = (
      <Route
        path="/(deals|hotel|registration|payment/contactUs)/"
        render={() => createPortal(cartORLoader, portalContainer)}
      />
    );

    return toRender;
  };

  maybeRenderDesktopFilters = () => {
    const {
      rooms,
      isDealMode,
      isMobileView,
      //dealSearchResults,
      deals,
      regionResults
    } = this.props;
    const portalContainer = document.getElementById("sfilter");
    if (!portalContainer) {
      // no container rendered for our portal
      return null;
    }
    if (isMobileView) {
      // we are not rendering this on mobile / tablets
      return null;
    }
    const hasResults =
      !isDealMode && !deals.length > 0
        ? (rooms && Object.values(rooms).length > 0) ||
          (regionResults && regionResults.length > 0)
        : //(deals && deals.length > 0)
          //: dealSearchResults && dealSearchResults.length > 0;
          false;

    const filterDisplay = hasResults ? <Filter /> : null;
    let toRender;

    toRender = (
      <Route
        path="/(deals|hotel|all|region|city)/"
        render={() => createPortal(filterDisplay, portalContainer)}
      />
    );

    return toRender;
  };

  renderCurrenciesDropdownPortal = () => {
    const { isMobileView } = this.props;
    let elementId = "currencies-changer-element";
    if (isMobileView) {
      elementId = "currencies-changer-mobile-element";
    }
    const portalContainer = document.getElementById(elementId);
    if (portalContainer == null || typeof portalContainer == "undefined") {
      // no container rendered for our portal
      return null;
    }
    return createPortal(<CurrenciesDropdown />, portalContainer);
  };

  renderDesktopBreadCrumbs = elem => {
    const { isMobileView, activeBreadCrumb, isRtl, titles } = this.props;
    // TODO: extract "scart" to a prop so we can inject it dynamically
    const portalContainer = document.getElementById(elem);
    if (!portalContainer) {
      // no container rendered for our portal
      return null;
    }
    if (isMobileView) {
      // we are not rendering this on mobile / tablets
      return null;
    }

    const breadCrumbsComponent = (
      // <BreadCrumbs
      //   activeBreadCrumb={activeBreadCrumb}
      //   isRtl={isRtl}
      //   titles={titles}
      // />
      <BreadCrumbsDots
        activeBreadCrumb={activeBreadCrumb}
        isRtl={isRtl}
        titles={titles}
      />
    );

    const toRender = (
      <Route
        path="/*"
        render={() => createPortal(breadCrumbsComponent, portalContainer)}
      />
    );

    return toRender;
  };

  /** @description
   * For now we just submiting our dummy form for redirection to the next step.
   * In the future we will handle this inside our SPA.
   */
  // onCheckoutClick = () => {
  //   /*
  //   const { actions, paxList, selectedHotelId } = this.props;
  //   console.log(paxList);
  //   actions.checkoutRooms(selectedHotelId);
  //   */
  //   requestAnimationFrame(() => {
  //     /* we must do the post on the next frame
  //     * so react has a chance to render and update the form with the new data.*/
  //     this.checkoutForm.submit();
  //   });
  // };

  /** @description
   * Continue to registration process
   */
  onCheckoutClick = () => {
    const { actions, routing } = this.props;
    actions.push(
      {
        pathname: "/registration",
        search: routing.location.search
      },
      null
    );
  };

  renderSearchResults = () => {
    const {
      generalHandlers,
      searchResultsRefAndHandlers,
      selectedPaxId,
      searchDataTimestamp,
      notifyRouteChange,
      ShowCancellationPolicy
    } = this.props;

    // filter out onRateSelection (scrolling) we will call it via this.onRateSelection
    // in the future we need to handle this name conflict better (maybe with get props function)
    const {
      onRateSelection,
      ...searchResultsRef
    } = searchResultsRefAndHandlers;

    return (
      <SearchResults
        requestDescriptor={selectedPaxId}
        renderLoader={this.renderResultsLoader}
        onShowRoomDetailsClick={this.onShowRoomDetailsClick}
        onRateReadMore={this.onRateReadMore}
        onShowMoreAmenities={this.onShowMoreAmenities}
        onRateSelection={this.onRateSelection}
        showSimpleClubLoginModal={this.showSimpleClubLoginModal}
        showMessage={this.showMessage}
        searchDataTimestamp={searchDataTimestamp}
        notifyRouteChange={notifyRouteChange}
        ShowCancellationPolicy={ShowCancellationPolicy}
        submitContactUsForm={this.submitContactUsForm}
        onShowRoomGalleryPopUp={this.onShowRoomGalleryPopUp}
        toggleExpandbleResultsView={this.toggleExpandbleResultsView}
        {...searchResultsRef}
        {...generalHandlers}
      />
    );
  };

  renderRegionResults = () => {
    const { generalHandlers, regionResultsRefAndHandlers } = this.props;
    const { ...regionResultsRef } = regionResultsRefAndHandlers;
    return (
      <RegionResults
        renderLoader={this.renderResultsLoader}
        showMessage={this.showMessage}
        onShowHotelDetailsClick={this.onShowHotelDetailsClick}
        notifyRouteChange={this.props.notifyRouteChange}
        {...generalHandlers}
        {...regionResultsRef}
        {...regionResultsRefAndHandlers}
      />
    );
  };

  renderAllResults = () => {
    const { generalHandlers, regionResultsRefAndHandlers } = this.props;
    const { ...regionResultsRef } = regionResultsRefAndHandlers;

    return (
      <AllResults
        renderLoader={this.renderResultsLoader}
        showMessage={this.showMessage}
        onShowHotelDetailsClick={this.onShowHotelDetailsClick}
        notifyRouteChange={this.props.notifyRouteChange}
        {...generalHandlers}
        {...regionResultsRef}
        {...regionResultsRefAndHandlers}
      />
    );
  };

  renderCityResults = () => {
    const { generalHandlers, regionResultsRefAndHandlers } = this.props;
    const { ...regionResultsRef } = regionResultsRefAndHandlers;

    return (
      <RegionResults
        renderLoader={this.renderResultsLoader}
        showMessage={this.showMessage}
        onShowHotelDetailsClick={this.onShowHotelDetailsClick}
        notifyRouteChange={this.props.notifyRouteChange}
        {...generalHandlers}
        {...regionResultsRef}
        {...regionResultsRefAndHandlers}
      />
    );
  };

  renderDealsResults = () => {
    const {
      ShowCancellationPolicy,
      dealResultsRefAndHandlers,
      generalHandlers
    } = this.props;

    // filter out onRateSelection (scrolling) we will call it via this.onDealRatesClick
    const {
      handleDealRatesGroupRef,
      handleDealsResultsRef,
      onDealRatesClick
    } = dealResultsRefAndHandlers;

    return (
      <DealsResults
        renderLoader={this.renderResultsLoader}
        onShowHotelDetailsClick={this.onShowHotelDetailsClick}
        onShowRoomDetailsClick={this.onShowRoomDetailsClick}
        onShowDealExtraDetailsClick={this.onShowDealExtraDetailsClick}
        onShowRoomGalleryPopUp={this.onShowRoomGalleryPopUp}
        onRateReadMore={this.onRateReadMore}
        onShowMoreAmenities={this.onShowMoreAmenities}
        onRateSelection={this.onRateSelection}
        showSimpleClubLoginModal={this.showSimpleClubLoginModal}
        showMessage={this.showMessage}
        ShowCancellationPolicy={ShowCancellationPolicy}
        redirectFormRef={this.setRedirectFormRef}
        handleDealRatesGroupRef={handleDealRatesGroupRef}
        handleDealsResultsRef={handleDealsResultsRef}
        onDealRatesClick={onDealRatesClick}
        toggleExpandbleResultsView={this.toggleExpandbleResultsView}
        {...generalHandlers}
      />
    );
  };

  renderRegistrationPayment = () => {
    const {
      generalHandlers,
      createRegistrationPaymentRefAndHandlers,
      paxList,
      actions,
      routing
    } = this.props;
    if (paxList && paxList[0] && paxList[0].id) {
      return (
        <RegistrationPayment
          renderLoader={this.renderResultsLoader}
          showMessage={this.showMessage}
          showSimpleClubLoginModal={this.showSimpleClubLoginModal}
          onShowAddonDetailsClick={this.onShowAddonDetailsClick}
          transactionId={this.props.transactionId}
          token={this.props.token}
          payerId={this.props.payerId}
          isPayPal={this.props.isPayPal}
          {...generalHandlers}
          {...createRegistrationPaymentRefAndHandlers}
          enablePrepayment={this.props.enablePrepayment}
        />
      );
    } else {
      actions.push(
        {
          pathname: "/hotel",
          search: routing.location.search
        },
        null
      );
    }
  };

  renderConfirmation = () => {
    const { generalHandlers, createConfirmationRefAndHandlers } = this.props;

    return (
      <Confirmation
        renderLoader={this.renderResultsLoader}
        showMessage={this.showMessage}
        {...generalHandlers}
        {...createConfirmationRefAndHandlers}
      />
    );
  };

  renderContactUs = () => {
    const { generalHandlers } = this.props;

    return (
      <ContactUs
        renderLoader={this.renderResultsLoader}
        submitContactUsForm={this.submitContactUsForm}
        {...generalHandlers}
      />
    );
  };

  renderNoResultsPage = () => {
    const { titles, hotelData, isRtl } = this.props;
    return (
      <Grid centered textAlign="center" stretched>
        <Grid.Column verticalAlign="middle" stretched>
          <NoResultsPage hotelData={hotelData} titles={titles} isRtl={isRtl} />
        </Grid.Column>
      </Grid>
    );
  };

  render() {
    const { globalModalData, cartHeight } = this.state;
    const {
      actions,
      lang,
      viewDirection,
      globalModal,
      isSearchboxModalOpen,
      isRtl,
      isMobileView,
      serverConfig,
      domainUrl,
      paxList,
      routing,
      generalHandlers,
      createRegistrationPaymentRefAndHandlers,
      selectedHotelId,
      checkinDate,
      checkoutDate
    } = this.props;
    const toastContainerClassName = isMobileView
      ? "toast-bottom-center"
      : isRtl
        ? "toast-bottom-right"
        : "toast-bottom-left";
    const searchQuery = `?lang=${lang}&selectedHotelId=${selectedHotelId}`;
    return (
      <div
        className={cx(styles.app, styles[viewDirection], {
          [styles.mobile]: isMobileView
        })}
        style={{ marginBottom: cartHeight + "px" }}
      >
        <ToastContainer
          ref={ref => (this.toastr = ref)}
          className={toastContainerClassName}
        />
        {this.renderCurrenciesDropdownPortal()}
        {this.maybeRenderDesktopCart()}
        {this.maybeRenderDesktopFilters()}
        {this.renderDesktopBreadCrumbs("breadcrumbs")}
        <Container fluid ref={generalHandlers.handlePageRef}>
          <Grid stackable relaxed stretched>
            {!serverConfig.received ? (
              <Grid.Column verticalAlign="middle" stretched>
                <GlobalLoader
                  size="massive"
                  active={true}
                  inline="centered"
                  interval={3000}
                  showContent={false}
                  isMobileView={isMobileView}
                  isRtl={isRtl}
                  indeterminate
                />
              </Grid.Column>
            ) : (
              <React.Fragment>
                <Grid.Row width={16}>
                  <GlobalModal
                    isRtl={isRtl}
                    open={globalModal.show}
                    title={globalModal.title}
                    content={globalModal.message}
                    handleClose={this.handleModalCancel}
                    isMobileView={isMobileView}
                    {...globalModalData}
                  />
                </Grid.Row>

                <Only when={isSearchboxModalOpen}>
                  <Grid.Row width={16}>
                    <SearchboxModal
                      domainUrl={domainUrl}
                      onClose={actions.closeSearchboxWin}
                      lang={lang}
                      isMobileView={isMobileView}
                      checkinDate={checkinDate}
                      checkoutDate={checkoutDate}
                    />
                  </Grid.Row>
                </Only>

                <Grid.Column mobile={16} tablet={16} computer={16} stretched>
                  <AnimatedSwitch
                    location={routing.location}
                    firstPath
                    timeout={450}
                    className="switch-wrapper"
                  >
                    <Route path="/contactUs" render={this.renderContactUs} />
                    <Route path="/hotel" render={this.renderSearchResults} />
                    <Route path="/all" render={this.renderAllResults} />
                    <Route path="/region" render={this.renderRegionResults} />
                    <Route path="/city" render={this.renderCityResults} />
                    <Route path="/deals" render={this.renderDealsResults} />
                    <Route
                      path="/registration"
                      render={() =>
                        paxList && paxList[0] && paxList[0].rateId ? (
                          <RegistrationPayment
                            renderLoader={this.renderResultsLoader}
                            showMessage={this.showMessage}
                            showSimpleClubLoginModal={
                              this.showSimpleClubLoginModal
                            }
                            onShowAddonDetailsClick={
                              this.onShowAddonDetailsClick
                            }
                            transactionId={this.props.transactionId}
                            token={this.props.token}
                            payerId={this.props.payerId}
                            isPayPal={this.props.isPayPal}
                            {...generalHandlers}
                            {...createRegistrationPaymentRefAndHandlers}
                            enablePrepayment={this.props.enablePrepayment}
                          />
                        ) : (
                          <Redirect
                            to={{
                              pathname: "/hotel",
                              search: searchQuery
                            }}
                          />
                        )
                      }
                    />
                    <Route
                      path="/confirmation"
                      render={this.renderConfirmation}
                    />
                    <Route
                      path="/noresults"
                      render={this.renderNoResultsPage}
                    />
                  </AnimatedSwitch>
                </Grid.Column>
                {paxList &&
                  paxList.length > 0 && (
                    <Route
                      path="/(hotel|deals)/"
                      render={() => (
                        <Grid.Column width={16}>
                          <Responsive maxWidth={screenSize.TABLET}>
                            <div
                              className={styles.staticCartWrapper}
                              ref={this.setStaticCartRef}
                            >
                              {this.maybeRenderMobileCart()}
                            </div>
                          </Responsive>
                        </Grid.Column>
                      )}
                    />
                  )}
              </React.Fragment>
            )}
          </Grid>
        </Container>
      </div>
    );
  }
}

App.propTypes = {
  serverConfig: PropTypes.object,
  visibleCart: PropTypes.bool,
  viewDirection: PropTypes.string,
  hotelData: PropTypes.object,
  rooms: PropTypes.object,
  addons: PropTypes.object,
  paxList: PropTypes.array,
  selectedPaxId: PropTypes.number,
  globalModal: PropTypes.object,
  domainUrl: PropTypes.string,
  isSearchboxModalOpen: PropTypes.bool,
  actions: PropTypes.object,
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  globalNotification: PropTypes.object,
  routing: PropTypes.object,
  selectedRegionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedCityCode: PropTypes.string,
  selectedHotelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedDealId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onRateSelection: PropTypes.func,

  //scrolling handlers related to searchresults
  searchResultsRefAndHandlers: PropTypes.object,
  dealResultsRefAndHandlers: PropTypes.object,

  //scrolling handlers
  generalHandlers: PropTypes.object,
  createRegistrationPaymentRefAndHandlers: PropTypes.object,
  createConfirmationRefAndHandlers: PropTypes.object,
  regionResultsRefAndHandlers: PropTypes.object,

  //scrolling handlers related to displayBar (cart)
  displayBarRefAndHandlers: PropTypes.object,
  enableSinglePaxCartSkipping: PropTypes.bool,
  singlePaxLoaded: PropTypes.bool,
  ShowCancellationPolicy: PropTypes.bool,
  searchDataTimestamp: PropTypes.number,
  notifyRouteChange: PropTypes.func,
  dealSearchResults: PropTypes.array,
  isDealMode: PropTypes.bool,
  isFetchingDealsSearchResultsReducer: PropTypes.bool,
  transactionId: PropTypes.string,
  token: PropTypes.string,
  payerId: PropTypes.string,
  isPayPal: PropTypes.bool,
  activeBreadCrumb: PropTypes.string,
  enableAddonsPopUp: PropTypes.bool,
  reservationId: PropTypes.number,
  registrationData: PropTypes.object,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  lang: PropTypes.string,
  selectedOption: PropTypes.object,
  newSearchPerformed: PropTypes.bool,
  deals: PropTypes.array,
  regionResults: PropTypes.array,
  alternativeSearch: PropTypes.array,
  enablePrepayment: PropTypes.bool
};

const mapStateToProps = store => {
  const {
    viewDirection,
    domainUrl,
    lang,
    globalModal,
    titles,
    visibleCart,
    isMobileView,
    hotelData,
    rooms,
    addons,
    paxList,
    selectedPaxId,
    routing,
    selectedRegionId,
    selectedCityCode,
    selectedHotelId,
    selectedDealId,
    globalNotification,
    enableSinglePaxCartSkipping,
    singlePaxLoaded,
    serverConfig,
    ShowCancellationPolicy,
    searchDataTimestamp,
    dealSearchResults,
    isDealMode,
    isFetchingDealsSearchResultsReducer,
    activeBreadCrumb,
    enableAddonsPopUp,
    isSearchboxModalOpen,
    reservationId,
    registrationData,
    checkinDate,
    checkoutDate,
    selectedOption,
    newSearchPerformed,
    deals,
    regionResults,
    alternativeSearch,
    enablePrepayment
  } = store;
  const isRtl = isRTL(store);

  return {
    isRtl,
    domainUrl,
    lang,
    isMobileView,
    rooms,
    addons,
    titles,
    paxList,
    globalModal,
    visibleCart,
    viewDirection,
    hotelData,
    selectedPaxId,
    routing,
    selectedRegionId,
    selectedCityCode,
    selectedHotelId,
    selectedDealId,
    globalNotification,
    enableSinglePaxCartSkipping,
    singlePaxLoaded,
    serverConfig,
    ShowCancellationPolicy,
    searchDataTimestamp,
    dealSearchResults,
    isDealMode,
    isFetchingDealsSearchResultsReducer,
    activeBreadCrumb,
    enableAddonsPopUp,
    isSearchboxModalOpen,
    reservationId,
    registrationData,
    checkinDate,
    checkoutDate,
    selectedOption,
    newSearchPerformed,
    deals,
    regionResults,
    alternativeSearch,
    enablePrepayment
  };
};

const mapDispatchToProps = dispatch => {
  const combinedActions = {
    ...modalActions,
    ...generalActions,
    ...cartActions,
    ...hotelsActions,
    ...ratesActions,
    ...paxActions,
    ...roomResultsActions,
    ...globalNotificationActions,
    ...mobileViewActions,
    ...dealActions,
    ...contactUsActions,
    getPlaceHolders,
    push,
    replace,
    toggleExpandbleView
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/containers/App.js